import { useEffect, useReducer, useRef } from "react";
import { getEventsData } from "../../services/board";
import { useLocation, useNavigate } from "react-router-dom";
import { getEventTasks } from "services/event";
import { getVendorInfo } from "services/vendor";

const initialArgs = {
    vendorData: {},
    callVendorDataAPI: true
};

const reducer = (state: any, action: any) => {
    return { ...state, ...action };
};

const useVendorHook = () => {
    const [state, setState] = useReducer(reducer, initialArgs);

    const fetchVendorData = async () => {
        try {
            console.log('Calling API again')
            const { data } = await getVendorInfo();
            setState({ ...state, vendorData: data, callVendorDataAPI: false });
        } catch (error: any) {
            console.log("Error while fetching vendors =", error);
        }
    };

    return {
        fetchVendorData,
        setState,
        ...state,
    };
};

export default useVendorHook;
